/**
 * Post-ATC bundle popup for StickyGolfPro.
 *
 * Opens after Add to Cart, shows the added product + up to 2 complementary
 * products as pre-toggled bundle items. No cart writes happen until the
 * user confirms — "Complete Bundle + Checkout" adds checked items then goes
 * to /checkout. "Continue to checkout →" skips everything and goes directly.
 *
 * Exposed as window.sgpPostATC = { open(productId), close(openDrawer) }
 * Called by custom.42-product-form.js after a successful cart add.
 */
(function () {
  'use strict';

  var overlay, panel, addedHeader, bundleBody;
  var ctaPrimary, ctaPrimaryText, ctaPrimarySub, ctaSecondary, ctaTertiary, closeBtn;
  var _items = []; // { variantId, toggled, savingsCents }
  var _busy = false;
  var _i18n = {}; // localized strings sourced from overlay dataset

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = root.replace(/\/+$/, '/');

  // ── Helpers ──────────────────────────────────────────────────────────────

  function fmt(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n : n.toFixed(2));
  }

  function stripHtml(html) {
    // DOMParser is inert — unlike innerHTML on a detached div, it can't fire
    // img/onerror handlers while parsing untrusted markup.
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    return (doc.body.textContent || '').trim();
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncate(str, max) {
    if (!str || str.length <= max) return str;
    return str.slice(0, max).replace(/\s\S*$/, '') + '…';
  }

  function calcSavings() {
    return _items.reduce(function (s, i) { return s + (i.toggled ? i.savingsCents : 0); }, 0);
  }

  function checkedCount() {
    return _items.filter(function (i) { return i.toggled; }).length;
  }

  // ── CTA state ─────────────────────────────────────────────────────────────

  function interpolate(template, vars) {
    return String(template || '').replace(/\{(\w+)\}/g, function (_, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : '{' + key + '}';
    });
  }

  function refreshCta() {
    var count = checkedCount();
    var savings = calcSavings();
    if (count === 0) {
      ctaPrimaryText.textContent = _i18n.ctaCheckout;
      ctaPrimarySub.textContent = '';
    } else {
      ctaPrimaryText.textContent = _i18n.ctaCompleteBundle;
      var template = count === 1 ? _i18n.ctaSubtitleSingular : _i18n.ctaSubtitlePlural;
      ctaPrimarySub.textContent = interpolate(template, { count: count, amount: fmt(savings) });
    }
  }

  function refreshSavingsLine() {
    var el = document.getElementById('sgp-savings-amount');
    if (el) el.textContent = fmt(calcSavings());
  }

  // ── Render added item ─────────────────────────────────────────────────────

  function renderAddedItem(cartItem) {
    if (!cartItem) { addedHeader.innerHTML = ''; return; }

    var compareHtml = '';
    if (cartItem.compare_at_price && cartItem.compare_at_price > cartItem.final_price) {
      compareHtml = '<span class="sgp-added-compare">' + fmt(cartItem.compare_at_price) + '</span>';
    }

    var imgHtml = '';
    if (cartItem.image) {
      var src = cartItem.image.replace(/(\.[^.?]+)(\?.*)?$/, '_120x120_crop_center$1');
      imgHtml = '<img src="' + src + '" alt="" width="60" height="60" loading="eager">';
    }

    var variantHtml = (cartItem.variant_title && cartItem.variant_title !== 'Default Title')
      ? '<div class="sgp-added-variant">' + escapeHtml(cartItem.variant_title) + '</div>'
      : '';

    addedHeader.innerHTML =
      '<div class="sgp-added-img">' + imgHtml + '</div>' +
      '<div class="sgp-added-info">' +
        '<div class="sgp-added-badge">' +
          '<svg width="14" height="14" viewBox="0 0 16 16" fill="none">' +
            '<circle cx="8" cy="8" r="7.5" stroke="#15A159"/>' +
            '<path d="M4.5 8.5L7 11l4.5-5" stroke="#15A159" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          _i18n.addedToCart +
        '</div>' +
        '<div class="sgp-added-name">' + escapeHtml(cartItem.product_title) + '</div>' +
        variantHtml +
        '<div class="sgp-added-prices">' +
          compareHtml +
          '<span class="sgp-added-price-current">' + fmt(cartItem.price) + '</span>' +
        '</div>' +
      '</div>';
  }

  // ── Render upsell rows ────────────────────────────────────────────────────

  function renderUpsells(products, offersByHandle) {
    _items = [];
    offersByHandle = offersByHandle || {};

    var rows = products.map(function (product, idx) {
      var offerMeta = offersByHandle[product.handle] || {};
      var variant = product.variants && product.variants[0];
      if (!variant) return '';

      var price = parseInt(variant.price, 10);
      var compareAt = variant.compare_at_price ? parseInt(variant.compare_at_price, 10) : 0;
      var savingsCents = (compareAt > price) ? (compareAt - price) : 0;

      _items.push({ variantId: variant.id, toggled: true, savingsCents: savingsCents });

      var imgSrc = '';
      if (product.images && product.images[0]) {
        var rawImg = typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
        if (rawImg) imgSrc = rawImg + (rawImg.indexOf('?') !== -1 ? '&' : '?') + 'width=112';
      }
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="" width="56" height="56" loading="lazy">'
        : '';

      var desc = offerMeta.description || truncate(stripHtml(product.body_html), 90);
      var descHtml = desc ? '<div class="sgp-prod-desc">' + escapeHtml(desc) + '</div>' : '';
      var titleText = escapeHtml(offerMeta.headline || product.title);

      var compareHtml = (compareAt > price)
        ? '<span class="sgp-prod-price-compare">' + fmt(compareAt) + '</span>'
        : '';
      var saveBadge = (savingsCents > 0)
        ? '<span class="sgp-prod-save-badge">' + interpolate(_i18n.saveAmount, { amount: fmt(savingsCents) }) + '</span>'
        : '';

      return '<div class="sgp-product-row" data-idx="' + idx + '">' +
        '<div class="sgp-prod-img">' + imgHtml + '</div>' +
        '<div class="sgp-prod-info">' +
          '<div class="sgp-prod-name">' + titleText + '</div>' +
          descHtml +
          '<div class="sgp-prod-prices">' +
            compareHtml +
            '<span class="sgp-prod-price-current">' + fmt(price) + '</span>' +
            saveBadge +
          '</div>' +
        '</div>' +
        '<div class="sgp-toggle-wrap">' +
          '<input type="checkbox" class="sgp-toggle-input" id="sgp-tog-' + idx + '" checked data-idx="' + idx + '">' +
          '<label class="sgp-toggle-label" for="sgp-tog-' + idx + '"></label>' +
        '</div>' +
      '</div>';
    });

    var totalSavings = fmt(calcSavings());

    var savingsLine = interpolate(_i18n.savingsLine, { amount: '{{SAVINGS_PLACEHOLDER}}' })
      .replace('{{SAVINGS_PLACEHOLDER}}', '<span id="sgp-savings-amount">' + totalSavings + '</span>');

    bundleBody.innerHTML =
      '<div class="sgp-bundle-section">' +
        '<div id="sgp-bundle-headline" class="sgp-bundle-headline">' + _i18n.headline + '</div>' +
        '<div class="sgp-bundle-savings-line">' + savingsLine + '</div>' +
        rows.join('') +
      '</div>';

    bundleBody.querySelectorAll('.sgp-toggle-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var idx = parseInt(this.dataset.idx, 10);
        _items[idx].toggled = this.checked;
        var row = bundleBody.querySelector('.sgp-product-row[data-idx="' + idx + '"]');
        if (row) row.classList.toggle('sgp-unchecked', !this.checked);
        refreshSavingsLine();
        refreshCta();
      });
    });
  }

  // ── Open ─────────────────────────────────────────────────────────────────

  async function open(productId) {
    if (!productId || _busy) return false;
    _busy = true;
    _items = [];

    overlay.removeAttribute('hidden');
    document.documentElement.setAttribute('scroll-lock', '');

    addedHeader.innerHTML = '<div class="sgp-loading">' + _i18n.loading + '</div>';
    bundleBody.innerHTML = '';
    ctaPrimaryText.textContent = _i18n.ctaCompleteBundle;
    ctaPrimarySub.textContent = '';
    ctaPrimary.disabled = false;

    try {
      // Read metafield-configured upsells from the product form element.
      // When set, these take priority over Shopify's recommendations API (which
      // can return empty results depending on session cookies / staff login state).
      var formEl = document.querySelector('product-form[data-product-id="' + productId + '"]');
      var upsellHandlesStr = formEl && formEl.dataset.upsellHandles;
      var upsellHandles = upsellHandlesStr ? upsellHandlesStr.split(',').filter(Boolean) : null;

      // Optional: per-offer metadata (headline/description/badge/cta_label) from upsell_offer metaobjects.
      // Keyed by product handle so we can attach the right offer to each fetched product.
      var offersByHandle = {};
      var offersMetaStr = formEl && formEl.dataset.upsellOffers;
      if (offersMetaStr) {
        try {
          var parsed = JSON.parse(offersMetaStr);
          if (Array.isArray(parsed)) {
            parsed.forEach(function (o) { if (o && o.handle) offersByHandle[o.handle] = o; });
          }
        } catch (e) { /* malformed JSON — fall through to product.body_html */ }
      }

      var fetchRecs = upsellHandles
        ? Promise.all(upsellHandles.slice(0, 2).map(function (h) {
            return fetch(root + 'products/' + h + '.js').then(function (r) { return r.json(); });
          }))
        : fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=4&intent=complementary').then(function (r) { return r.json(); });

      var results = await Promise.all([
        fetch(root + 'cart.js').then(function (r) { return r.json(); }),
        fetchRecs
      ]);

      var cartData = results[0];
      var recs;

      if (upsellHandles) {
        recs = results[1].filter(function (p) {
          return p.available && String(p.id) !== String(productId);
        });
      } else {
        var recsData = results[1];
        recs = (recsData.products || []).filter(function (p) {
          return p.available && String(p.id) !== String(productId);
        });

        // Fallback: if no complementary products configured, use related recommendations
        if (!recs.length) {
          var fallback = await fetch(root + 'recommendations/products.json?product_id=' + productId + '&limit=4&intent=related').then(function (r) { return r.json(); });
          recs = (fallback.products || []).filter(function (p) {
            return p.available && String(p.id) !== String(productId);
          });
        }
      }

      // Cap at 2
      recs = recs.slice(0, 2);

      if (!recs.length) {
        _dismiss(false);
        _busy = false;
        return false;
      }

      var cartItem = (cartData.items || []).find(function (i) {
        return String(i.product_id) === String(productId);
      });

      renderAddedItem(cartItem || null);
      renderUpsells(recs, offersByHandle);
      refreshCta();
      _busy = false;
      return true;

    } catch (e) {
      _dismiss(false);
      _busy = false;
      return false;
    }
  }

  // ── Primary CTA ───────────────────────────────────────────────────────────

  async function handlePrimaryClick() {
    if (_busy) return;
    var toAdd = _items.filter(function (i) { return i.toggled; });

    if (toAdd.length) {
      _busy = true;
      ctaPrimary.disabled = true;
      ctaPrimaryText.textContent = _i18n.adding;
      ctaPrimarySub.textContent = '';
      try {
        await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: toAdd.map(function (i) { return { id: i.variantId, quantity: 1 }; })
          })
        });
      } catch (e) { /* best-effort — proceed to checkout regardless */ }
      _busy = false;
    }

    overlay.setAttribute('hidden', '');
    document.documentElement.removeAttribute('scroll-lock');
    window.location.href = '/checkout';
  }

  // ── Dismiss ───────────────────────────────────────────────────────────────

  function _dismiss(openDrawer) {
    overlay.setAttribute('hidden', '');
    document.documentElement.removeAttribute('scroll-lock');
    if (openDrawer) {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
    }
  }

  function close(openDrawer) {
    _dismiss(openDrawer !== false);
  }

  // ── Init ─────────────────────────────────────────────────────────────────

  function init() {
    overlay = document.getElementById('sgp-post-atc-overlay');
    if (!overlay) return;

    _i18n = {
      headline: overlay.dataset.headline || 'Complete your bundle',
      loading: overlay.dataset.loading || 'Loading…',
      adding: overlay.dataset.adding || 'Adding…',
      addedToCart: overlay.dataset.addedToCart || 'Added to Cart',
      saveAmount: overlay.dataset.saveAmount || 'Save {amount}',
      savingsLine: overlay.dataset.savingsLine || 'Add both below and save an additional {amount}',
      ctaCheckout: overlay.dataset.ctaCheckout || 'Checkout',
      ctaCompleteBundle: overlay.dataset.ctaCompleteBundle || 'Complete Bundle + Checkout',
      ctaSubtitleSingular: overlay.dataset.ctaSubtitleSingular || '1 item · Save an additional {amount}',
      ctaSubtitlePlural: overlay.dataset.ctaSubtitlePlural || '{count} items · Save an additional {amount}'
    };

    panel = document.getElementById('sgp-post-atc-panel');
    addedHeader = document.getElementById('sgp-added-header');
    bundleBody = document.getElementById('sgp-bundle-body');
    ctaPrimary = document.getElementById('sgp-cta-primary');
    ctaPrimaryText = document.getElementById('sgp-cta-primary-text');
    ctaPrimarySub = document.getElementById('sgp-cta-primary-sub');
    ctaSecondary = document.getElementById('sgp-cta-secondary');
    ctaTertiary = document.getElementById('sgp-cta-tertiary');
    closeBtn = document.getElementById('sgp-post-atc-close');

    closeBtn.addEventListener('click', function () { _dismiss(false); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) _dismiss(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) _dismiss(false);
    });

    ctaPrimary.addEventListener('click', handlePrimaryClick);

    ctaSecondary.addEventListener('click', function () {
      overlay.setAttribute('hidden', '');
      document.documentElement.removeAttribute('scroll-lock');
      window.location.href = '/checkout';
    });

    if (ctaTertiary) {
      ctaTertiary.addEventListener('click', function () { _dismiss(false); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.sgpPostATC = { open: open, close: close };
})();
